import { useContext, useEffect } from 'react';
import { TableContext } from './TableContext.es.js';
import { TABLE_EVENTS } from './Table.constants.es.js';

const useTableRowEventListener = (rowIndex, rowRef, isFocus, setIsFocus) => {
  const { tableBodyNode, setFocusedRowIndex } = useContext(TableContext);
  useEffect(() => {
    const listener = (e) => {
      var _a, _b;
      const {
        detail: { newRowIndex, didKeyboardNav }
      } = e;
      if (rowIndex === newRowIndex) {
        setIsFocus(true);
        setFocusedRowIndex(newRowIndex);
        if (didKeyboardNav) {
          ((_a = rowRef.current) == null ? void 0 : _a.scrollIntoView) && ((_b = rowRef.current) == null ? void 0 : _b.scrollIntoView({
            block: "center",
            inline: "nearest"
          }));
        }
        return;
      }
      if (isFocus) {
        setIsFocus(false);
      }
    };
    tableBodyNode == null ? void 0 : tableBodyNode.addEventListener(TABLE_EVENTS.ROW_CHANGED, listener);
    return () => tableBodyNode == null ? void 0 : tableBodyNode.removeEventListener(TABLE_EVENTS.ROW_CHANGED, listener);
  }, [tableBodyNode, isFocus, setFocusedRowIndex, setIsFocus, rowIndex, rowRef]);
};

export { useTableRowEventListener };
//# sourceMappingURL=Table.hooks.es.js.map
